<template>

  <div style="display: flex; text-align: center; ">
    <div style="display: flex; align-items: center">
      <img v-if="code == 'motor'" style="width: 40px;height: 40px;" :src= "motorIcon === 'mid' ? midIcon:inwheelIcon "  alt="">
      <img v-else-if="code == 'battery'" style="width: 40px;height: 40px;" :src="batteryImgUrl" alt="">
      <img v-else-if="code == 'box'" style="width: 40px;height: 40px;" :src="boxImgUrl" alt="">
      <img v-else style="width: 40px;height: 40px;" src="@/assets/dashboard.webp" alt="">
      <div style="font-size: 22px;margin-left: 10px; margin-right: 10px;">{{ $t(name) }}</div>
      <el-tag size="large" :type="connected ? 'success' : 'info'">{{
          connected ? $t('ProductUpgrade.online') :
              $t('ProductUpgrade.offline')
        }}
      </el-tag>
    </div>

    <div style="margin: 5px 20px;" v-for="item, key in processedInfos" :key="key">
      <div style="color: gray;">{{ $t(item.name) }}</div>
      <div style="font-size: 0.8em;color: gray;margin-top: 5px;">{{ item.value || '-' }}</div>
    </div>

    <div v-loading="loading" style="display: flex;align-items: center">

      <el-button @click="connect" link type="success">
        <el-icon>
          <Switch />
        </el-icon>
        {{ $t('ProductUpgrade.reconnecting') }}
      </el-button>
      <el-popover
          v-if="!connected && !loading"
          placement="right"
          :width="400"
          trigger="hover"
      >
        <template #reference>
          <el-icon style="margin-left: 8px; cursor: pointer;">
            <QuestionFilled />
          </el-icon>
        </template>
        <div style="line-height: 1.8;">
          <p>1. {{ $t('ProductUpgrade.helpCheckConnection') }}</p>
          <p>2. {{ $t('ProductUpgrade.helpCheckPort') }}</p>
          <p>3. {{ $t('ProductUpgrade.helpCheckToolkit') }}</p>
          <p>4. {{ $t('ProductUpgrade.helpCheckDriver') }}</p>
          <p>5. {{ $t('ProductUpgrade.helpTryNewPort') }}</p>
          <p>6. {{ $t('ProductUpgrade.helpContactSupport') }}</p>
        </div>
      </el-popover>
    </div>
  </div>
  <div v-if="code == 'motor'" style="margin: 5px 20px 15px 20px; font-size: 14px; text-align: left;">（{{ $t('ProductUpgrade.uartSystemNotice') }}）</div>
  <div style="height: 60vh; margin: 10px; border: 1px solid #e2e2e2;text-align: left;">

    <div v-if="connected">

      <div v-for=" item, key  in  uploadFiles " :key="key">
        <div v-if="item.visible" style="display: flex;flex-direction: row; margin: 20px; align-items: center">
          <div style="margin-right: 10px;">{{ $t(item.name) }}</div>
          <el-select v-model="item.fileName" :clearable="true" style="width: 340px" @clear="clearSelectFile(code,key)" :disabled="code === 'box'">
            <el-option v-for=" option  in  item.options " :key="option.id" :value="option.fileName">{{
                option.fileName }}
            </el-option>
          </el-select>
          <el-upload :action="uploadUrl" :headers="getUploadHeader()" :on-success="res => uploadSuccess(res, code, key) "
                     :show-file-list="false" style="display: flex;align-items: center;" :before-upload="beforeUpload"  accept=".bin" :disabled="code === 'box'">
            <el-button :class="{'button-background-color': code !== 'box'}" style="margin-left: 20px;" :disabled="code === 'box'">{{
                $t('ProductUpgrade.uploadLocalFile')
              }}
            </el-button>
          </el-upload>

          <!-- 将 checking 按钮移到这里 -->
          <el-button v-if="connected && showCheckButton && code !== 'battery'" @click="check" :class="{'button-background-color': code === 'box'}" style="margin-left: 20px;">
            {{ $t('ProductUpgrade.onlineAutoUpgrade') }}
          </el-button>

        </div>
      </div>

      <!-- 升级次数信息显示 - 只在数据加载后、upgradeType为1且需要显示申请按钮时显示 -->
      <div v-if="upgradeCountLoaded && upgradeCountInfo.upgradeType === 1 && showApplyButton" style="margin: 20px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <!-- 申请按钮 - 当次数为0时显示 -->
          <div style="display: flex; align-items: center;">
            <span style="margin-right: 10px; color: #606266; font-size: 14px;">{{ $t('ProductUpgrade.upgradeCountExhausted') }}</span>
            <el-button
                @click="showApplyDialog"
                :loading="applyLoading"
                type="primary"
                size="small">
              {{ $t('ProductUpgrade.applyUpgradeCount') }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div style="margin-top: 20px;">
        <el-button :class="{'button-background-color': code !== 'box'}" @click="() => { upgrade(code) }" :disabled="btnUpgrade || code === 'box'" style="margin-left: 300px;">
          {{ $t('ProductUpgrade.manualUpgrade') }}
        </el-button>

        <!-- 新增查看最近文件按钮 - 只在OGGI组织显示且非电池模块、非盒子模块 -->
        <el-button v-if="isOGGIOrganization && code !== 'battery' && code !== 'box'" @click="showRecentFiles" style="margin-left: 10px;" type="info">
          {{ $t('ProductUpgrade.viewRecentFiles') }}
        </el-button>
      </div>

    </div>
    <div v-else>
      <div style="display: flex; width: 100%;height: 100%; text-align: center;justify-content: center;">
        <img src="@/assets/noDeviceConnect.webp" alt="" width="570" height="376">
      </div>
      <div style="text-align: center;color: gray">{{ $t(name) }} {{ $t('ProductUpgrade.noConnection') }}</div>
    </div>
  </div>
  <el-dialog :model-value="dialogVisible" :title="isRestarting ? $t('ProductUpgrade.upgradeCompleted') : $t('ProductUpgrade.upgrading') " align-center
             :close-on-click-modal="false" :show-close="false">
    <div v-if="uploadFiles?.config?.fileName && code=='motor'">
      <div>{{ $t('ProductUpgrade.parameterFileUpgrade') }}</div>
      <el-progress :percentage="configPercentage"></el-progress>
    </div>

    <div v-if="uploadFiles?.firmware?.fileName">
      <div>{{ $t('ProductUpgrade.firmwareUpgrade') }}</div>
      <el-progress :percentage="percentage"></el-progress>
    </div>

    <div v-if="uploadFiles?.config?.fileName && code=='display'">
      <div>{{ $t('ProductUpgrade.imageFileUpgrade') }}</div>
      <el-progress :percentage="configPercentage"></el-progress>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-popconfirm :title="$t('ProductUpgrade.confirmCancel')" @confirm="upgradeCancel">
          <template #reference>
            <el-button :disabled="isRestarting" :loading="cancelLoading">{{ $t('ProductUpgrade.cancel') }}</el-button>
          </template>
        </el-popconfirm>
        
        <!-- 完成按钮 - 当进度达到100%时显示 -->
        <el-button 
          v-if="isRestarting" 
          type="primary" 
          @click="handleUpgradeComplete"
        >{{ $t('ProductUpgrade.complete') }}</el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog :model-value="checkVisiable" width="400px" :show-close="false" >
    <h3>
      <template v-if="firmwareFileText && firmwareVersionNewer">
        {{ $t('ProductUpgrade.newVersionAvailable') }} {{ firmwareFileText }} 
      </template>
      <template v-if="(firmwareFileText && firmwareVersionNewer) && (lastConfigFile && configVersionNewer)">
        <br>
      </template>
      <template v-if="lastConfigFile && configVersionNewer">
        {{ $t('ProductUpgrade.parameterVersion') }} {{ configFileText }} 
      </template>
      {{ $t('ProductUpgrade.updateIs') }}
    </h3>
    <template #footer>
      <el-button @click="checkVisiable = false" type="default">{{ $t('ProductUpgrade.cancel') }}</el-button>
      <el-button @click="checkAndUpgrade" type="primary">{{ $t('ProductUpgrade.upgrade') }}</el-button>
    </template>

  </el-dialog>

  <!-- 新增查看最近文件弹窗 -->
  <el-dialog :model-value="recentFilesVisible" :title="$t('ProductUpgrade.recentFiles')" width="50%" :show-close="true" @close="recentFilesVisible = false" @update:model-value="recentFilesVisible = $event">
    <el-tabs v-model="recentFilesActiveTab" @tab-change="handleRecentFilesTabChange">
      <el-tab-pane :label="$t('ProductUpgrade.firmware')" name="firmware">
        <el-table :data="recentFirmwareList" style="width: 100%">
          <el-table-column prop="name" :label="$t('ProductUpgrade.firmwareName')"  />
          <el-table-column prop="hardware_version" :label="$t('ProductDiagnosis.hardwareVersion')" />
          <el-table-column prop="software_version" :label="$t('ProductDiagnosis.softwareVersion')"  />
        </el-table>

      </el-tab-pane>
      <el-tab-pane v-if="code === 'motor'" :label="$t('ProductUpgrade.parameterFile')" name="parameter">
        <el-table :data="recentParameterList" style="width: 100%">
          <el-table-column prop="name" :label="$t('ProductUpgrade.fileName')"  />
          <el-table-column prop="hardware_version" :label="$t('ProductDiagnosis.hardwareVersion')"  />
          <el-table-column prop="config_version" :label="$t('ProductDiagnosis.softwareVersion')"  />
        </el-table>

      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button @click="recentFilesVisible = false" type="default">{{ $t('ProductUpgrade.close') }}</el-button>
    </template>
  </el-dialog>

  <!-- 申请升级次数对话框 -->
  <el-dialog :model-value="applyDialogVisible" :title="$t('ProductUpgrade.applyUpgradeCount')" width="600px" :show-close="true" @close="closeApplyDialog" @update:model-value="applyDialogVisible = $event">
    <el-form :model="applyForm" :rules="applyRules" ref="applyFormRef" label-width="100px">
      <el-form-item :label="$t('ProductUpgrade.applicantId')" prop="applicantId">
        <el-input v-model="applyForm.applicantId" disabled />
      </el-form-item>
      <el-form-item :label="$t('ProductUpgrade.applyReason')" prop="applyReason">
        <el-input
            v-model="applyForm.applyReason"
            type="textarea"
            :rows="4"
            :placeholder="$t('ProductUpgrade.applyReasonPlaceholder')"
            maxlength="200"
            show-word-limit
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="closeApplyDialog" type="default">{{ $t('ProductUpgrade.cancel') }}</el-button>
      <el-button @click="submitApply" :loading="applyLoading" type="primary">{{ $t('ProductUpgrade.confirmApply') }}</el-button>
    </template>
  </el-dialog>

  <!-- 升级完成版本信息弹窗 -->
  <el-dialog 
    :model-value="versionInfoVisible" 
    :title="t('ProductUpgrade.upgradeComplete')" 
    width="500px" 
    :show-close="true" 
    draggable
    @close="closeVersionInfoDialog" 
    @update:model-value="handleVersionInfoDialogUpdate"
  >
    <div class="version-info-container">
      <h3 style="text-align: center; margin-bottom: 20px;">{{ t('ProductUpgrade.versionUpgradeInfo') }}</h3>
      <el-descriptions :column="1" border>
        <el-descriptions-item :label="t('ProductUpgrade.beforeUpgradeFirmware')">
          {{ upgradeVersionInfo.oldFirmwareVersion || '-' }}
        </el-descriptions-item>
        <el-descriptions-item :label="t('ProductUpgrade.afterUpgradeFirmware')">
          {{ upgradeVersionInfo.newFirmwareVersion || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <template #footer>
      <el-button @click="closeVersionInfoDialog" type="primary">{{ t('ProductUpgrade.close') }}</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {defineProps, defineEmits, computed, ref, watch, onMounted, onUnmounted} from 'vue';
import {QuestionFilled, Switch} from "@element-plus/icons-vue";

import i18n from "@/i18n";
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import api from '@/views/ProductUpgrade/api.js';
import { createDiffUpgradeApplyRecord } from '@/api/api';
import { compareversions } from '@/utils/common.js';

const t = i18n.global.t; // 将 i18n.global.t 方法赋值给变量 t
const router = useRouter();

// 定义组件可以触发的事件
const emit = defineEmits(['update:dialogVisible', 'resetUpgradeStatus']);

// 升级历史记录响应式变量
const upgradeHistory = ref([])
const hasUpgraded = ref(false) // 标记设备是否已升级过
const showUpgradeHistory = ref(false) // 控制升级历史的显示
const upgradeHistoryTimer = ref(null) // 存储定时器ID
const forceUpdate = ref(0) // 强制更新计数器

// 检查组织名称是否为L1或Atala（用于显示升级历史）
const props = defineProps({
  code: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: ''
  },

  connected: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  dialogVisible: {
    type: Boolean,
    default: false
  },
  // 新增：从父组件接收升级完成状态
  upgradeCompleted: {
    type: Boolean,
    default: false
  },

  percentage: {},
  configPercentage: {},

  infos: {
    type: Array,
    default() {
      return []
    }
  },
  uploadFiles: {
    type: Object,
    default() {
      return {}
    }
  },
  connect: {
    type: Function,
    required: true,
  },
  upgrade: {
    type: Function,
    required: true
  },
  uploadSuccess: {
    type: Function,
    required: true
  },
  upgradeCancel: {
    type: Function,
    required: true
  },
  cancelLoading: {
    type: Boolean,
    required: true
  },
  lastFirmwareFile: {
    type: String,
    required: true
  },
  lastConfigFile: {
    type: String,
    required: true
  },
  checkUpgrade: {
    type: Function,
  },
  checkUpgradeForP8: {
    type: Function
  },
  motorIcon:{
    type: String
  },
  clearSelectFile:{
    type:Function,
    require: true
  },
  upgradeCountInfo: {
    type: Object,
    default: () => ({
      userId: '',
      remainingCount: 0,
      upgradeType: 0
    })
  },
  showApplyButton: {
    type: Boolean,
    default: false
  },
  applyLoading: {
    type: Boolean,
    default: false
  },
  applyUpgradeCount: {
    type: Function,
    required: true
  },
  upgradeCountLoaded: {
    type: Boolean,
    default: false
  },
  afterVersion: {
    type: String,
    default: ''
  },
  hasSerialUpgrade: {
    type: Boolean,
    default: true
  }
})

const midIcon = require('@/assets/image/mid-motor.png')
const inwheelIcon = require('@/assets/image/hub-motor.png')
const batteryImgUrl = require("@/assets/battery.webp")
const boxImgUrl = require("@/assets/box.png")


const btnUpgrade = computed(() => {
  return !(props.connected && (props.uploadFiles.firmware?.fileName?.length > 0 || props.uploadFiles?.config?.fileName?.length > 0))
})
// 处理电机型号显示的计算属性
const processedInfos = computed(() => {
  // 深拷贝infos数组，避免修改原始数据
  const infosCopy = JSON.parse(JSON.stringify(props.infos))
  
  // 只有当设备是电机时才进行处理
  if (props.code === 'motor' && Array.isArray(infosCopy)) {
    // 尝试多种可能的key值来获取硬件版本、固件版本和型号
    const hardwareVersionItem = infosCopy.find(item => 
      item.key === 'hardwareversion' || 
      item.key === 'hardwareVersion' || 
      item.name.includes('hardware') || 
      item.name.includes('Hardware')
    );
    
    const firmwareVersionItem = infosCopy.find(item => 
      item.key === 'softwareversion' || 
      item.key === 'softwareVersion' || 
      item.name.includes('firmware') || 
      item.name.includes('Firmware') || 
      item.name.includes('version') || 
      item.name.includes('Version')
    );
    
    const modelItem = infosCopy.find(item => 
      item.key === 'model' || 
      item.name.includes('model') || 
      item.name.includes('Model')
    );
    
    // 检查是否都存在
    if (hardwareVersionItem && firmwareVersionItem && modelItem) {
      const hardwareVersion = hardwareVersionItem.value || ''
      const firmwareVersion = firmwareVersionItem.value || ''
      const specialFirmwareVersions = ['H11Z01', 'H12500', 'H12202']
      
      // 检查是否满足条件：硬件版本C5M210
      if (hardwareVersion === 'C5M210') {
        // 获取固件版本的前4位
        const firmwareVersionPrefix = firmwareVersion.substring(0, 4);
        // 检查前4位是否在指定列表中
        const isSpecialFirmware = specialFirmwareVersions.some(version => 
          version.startsWith(firmwareVersionPrefix)
        );
        
        // 如果固件版本前4位在指定列表中，显示M1000
        if (isSpecialFirmware) {
          modelItem.value = 'M1000'
        } else {
          // 如果固件版本前4位不在指定列表中，显示M81
          modelItem.value = 'M81'
        }
      }
    }
  }
  
  return infosCopy
})

// 检查组织名称是否为OGGI
const isOGGIOrganization = computed(() => {
  const organizationName = localStorage.getItem('organizationName')
  return organizationName === 'OGGI'
})

// 检查组织名称是否为OGGI或Atala，或者用户是否为管理员（用于检查按钮）
const showCheckButton = computed(() => {
  const organizationName = localStorage.getItem('organizationName')
  const userRoles = JSON.parse(localStorage.getItem('user_role')) || []
  const isAdmin = userRoles.includes("Super Admin") || userRoles.includes("管理员") || userRoles.includes("Admin") || userRoles.includes("内部管理员") || userRoles.includes("SuperAdmin")
  return organizationName === 'OGGI' || organizationName === 'Atala' || isAdmin
})

const firmwareFileText = computed(() => {
  // 尝试从recentFirmwareList中查找匹配的固件信息
  if (props.lastFirmwareFile && recentFirmwareList.value.length > 0) {
    // 提取当前选中的文件名
    const currentFileName = props.lastFirmwareFile.substring(props.lastFirmwareFile.lastIndexOf('\\') + 1)
    
    // 查找与当前文件名匹配的固件信息
    const matchingFirmware = recentFirmwareList.value.find(item => 
      item.name && item.file_name === currentFileName
    )

    // 如果找到匹配的文件且有版本信息，返回版本信息
    if (matchingFirmware && matchingFirmware.software_version && matchingFirmware.software_version !== '-') {
      return matchingFirmware.software_version
    }
  }
  
  // 后备方案：如果找不到匹配信息或列表为空，返回文件名
  if (props.lastFirmwareFile) {
    var index = props.lastFirmwareFile.lastIndexOf('\\')
    return props.lastFirmwareFile.substring(index + 1, props.lastFirmwareFile.length)
  }
  return ''
})
const configFileText = computed(() => {
    
  // 尝试从recentParameterList中查找匹配的参数信息
  if (props.lastConfigFile && recentParameterList.value.length > 0) {
    // 提取当前选中的文件名
    const currentFileName = props.lastConfigFile.substring(props.lastConfigFile.lastIndexOf('\\') + 1)
    
    // 查找与当前文件名匹配的配置信息
    const matchingConfig = recentParameterList.value.find(item => 
      item.name && item.file_name === currentFileName
    )

    // 如果找到匹配的文件且有版本信息，返回版本信息
    if (matchingConfig && matchingConfig.config_version && matchingConfig.config_version !== '-') {
      return matchingConfig.config_version
    }
  }
  
  // 后备方案：如果找不到匹配信息或列表为空，返回文件名
  if (props.lastConfigFile) {
    var index = props.lastConfigFile.lastIndexOf('\\')
    return props.lastConfigFile.substring(index + 1, props.lastConfigFile.length)
  }
  return ''
})

// 使用响应式变量而不是计算属性，默认不处于重启状态
const isRestarting = ref(false)

// 获取当前固件版本
function getCurrentFirmwareVersion() {
  if (props.infos && Array.isArray(props.infos)) {
    if (props.code === 'motor') {
      // 电机设备获取软件版本
      const versionItem = props.infos.find(item => item.key === 'softwareversion');
      return versionItem ? versionItem.value || '' : '';
    } else if (props.code === 'display') {
      // 仪表设备获取版本信息
      const versionItem = props.infos.find(item => item.key === 'softwareversion');
      return versionItem ? versionItem.value || '' : '';
    } else if (props.code === 'battery') {
      // 电池设备获取版本信息
      const versionItem = props.infos.find(item => item.key === 'softwareversion');
      return versionItem ? versionItem.value || '' : '';
    } else if (props.code === 'box') {
      // 盒子设备获取版本信息
      const versionItem = props.infos.find(item => item.key === 'softwareversion');
      return versionItem ? versionItem.value || '' : '';
    }
  }
  return '';
}

// 获取当前参数版本
function getCurrentParameterVersion() {
  if (props.infos && Array.isArray(props.infos)) {
    if (props.code === 'motor') {
      const versionItem = props.infos.find(item => item.key === 'parameterversion');
      return versionItem ? versionItem.value || '' : '';
    } else if (props.code === 'battery') {
      const versionItem = props.infos.find(item => item.key === 'parameterversion');
      return versionItem ? versionItem.value || '' : '';
    } else if (props.code === 'box') {
      const versionItem = props.infos.find(item => item.key === 'parameterversion');
      return versionItem ? versionItem.value || '' : '';
    }
  }
  return '';
}

// 监听对话框可见性变化
  watch(() => props.dialogVisible, (newVal) => {
    if (newVal && !isRestarting.value) {
      // 对话框打开且不是重启状态，说明是升级开始
      const currentVersion = getCurrentFirmwareVersion();
      if (currentVersion) {
        // 保存升级开始时的版本
        localStorage.setItem(`upgradeStartVersion_${props.code}`, currentVersion);
      }
    }
  }, { immediate: true })

// 监听升级完成状态的变化
  watch(() => props.upgradeCompleted, (newVal) => {
    if (newVal) {
      const organizationName = localStorage.getItem('organizationName')
      isRestarting.value = true
      
      if (organizationName === 'Atala') {
        // 获取升级前的版本
        const oldVersion = localStorage.getItem(`upgradeStartVersion_${props.code}`);
        
        // 设置升级标记，但不立即显示弹窗
        if (oldVersion) {
          // 更新升级历史并设置升级标记
          // 清除之前的定时器（如果存在）
          if (upgradeHistoryTimer.value) {
            clearTimeout(upgradeHistoryTimer.value);
            upgradeHistoryTimer.value = null;
          }
          
          // 更新升级历史
          upgradeHistory.value = [{
            oldVersion: oldVersion,
            upgradeTime: new Date().toLocaleString()
          }];
          
          // 设置升级标记，表示该设备已升级过
          localStorage.setItem(`hasUpgraded_${props.code}`, 'true');
          hasUpgraded.value = true; // 更新响应式变量
          
          // 显示升级历史
          showUpgradeHistory.value = true;
          
          // 保存显示状态和显示开始时间到localStorage
          const showStartTime = Date.now();
          localStorage.setItem(`upgradeHistoryShowStart_${props.code}`, showStartTime.toString());
          localStorage.setItem(`upgradeHistoryShouldShow_${props.code}`, 'true');
          
          // 强制更新视图
          forceUpdate.value++;
          
          // 计算剩余时间（30分钟）
          const remainingTime = 30 * 60 * 1000; // 30分钟
          
          // 设置剩余时间后自动隐藏升级历史
          upgradeHistoryTimer.value = setTimeout(() => {
            showUpgradeHistory.value = false;
            upgradeHistoryTimer.value = null;
            // 清除localStorage中的显示状态
            localStorage.removeItem(`upgradeHistoryShouldShow_${props.code}`);
            localStorage.removeItem(`upgradeHistoryShowStart_${props.code}`);
          }, remainingTime);
        }
      } else {
        // 确保版本信息弹窗不显示
        versionInfoVisible.value = false
      }
    }
  }, { deep: true })

// 监听isRestarting状态变化
  watch(() => isRestarting.value, (newVal, oldVal) => {
    if (newVal && !oldVal && props.dialogVisible) {
      // 升级完成，显示完成按钮
    }
  })

const uploadUrl = process.env.VUE_APP_API_URL + '/api/common/upload'

// 修改为函数而不是computed属性
function getUploadHeader() {
  const currentToken = localStorage.getItem('token')
  return {
    Authorization: 'Bearer ' + currentToken
  }
}

// 处理升级完成
  function handleUpgradeComplete() {
    // 获取当前组织名称
    const organizationName = localStorage.getItem('organizationName')
    
    if (organizationName === 'Atala') {
      // Atala组织：显示版本信息弹窗
      // 获取升级前的版本信息
      const oldFirmwareVersion = localStorage.getItem(`upgradeStartVersion_${props.code}`);
      
      // 延迟显示版本信息弹窗，确保设备已重新加载
      setTimeout(() => {
        // 在setTimeout内部重新获取组织名称，确保使用最新值
        const currentOrganizationName = localStorage.getItem('organizationName')
        
        // 先重新连接设备以获取最新的版本信息
        props.connect()
        
        // 等待一小段时间确保设备信息已更新
        setTimeout(() => {
          // 获取升级后的版本信息 - 优先使用WebSocket返回的版本
          let newFirmwareVersion = '';
          
          // 优先使用从WebSocket返回指令中获取的版本信息
          if (props.afterVersion) {
            newFirmwareVersion = props.afterVersion;
          } else {
            // 如果没有WebSocket版本信息，则从设备信息中获取（作为备用方案）
            newFirmwareVersion = getCurrentFirmwareVersion();
          }
          
          // 设置版本信息
          upgradeVersionInfo.value = {
            oldFirmwareVersion: oldFirmwareVersion || '',
            newFirmwareVersion: newFirmwareVersion || '',
            oldParameterVersion: '',
            newParameterVersion: ''
          };
          
          // 使用重新获取的组织名称进行检查
          if (currentOrganizationName === 'Atala') {
            // 显示版本信息弹窗
            versionInfoVisible.value = true
          } else {
            // 确保非Atala组织不显示弹窗
            versionInfoVisible.value = false
          }
          
          // 关闭升级进度对话框
          emit('update:dialogVisible', false)
          
          // 重置重启状态，以便下次使用
          isRestarting.value = false
        }, 500); // 额外等待500ms确保设备信息已更新
      }, 1000); // 延迟1秒，确保设备已重新加载
    } else {
      // 其他组织：直接关闭升级进度对话框并重新连接设备
      // 确保版本信息弹窗不显示
      versionInfoVisible.value = false
      
      // 关闭升级进度对话框
      emit('update:dialogVisible', false)
      
      // 延迟重新连接设备，确保对话框已关闭
      setTimeout(() => {
        // 重新连接设备
        props.connect()
        
        // 在设备重新连接后再重置重启状态
        isRestarting.value = false
      }, 100);
    }
  }

const checkVisiable = ref(false)
// 新增响应式变量，用于控制升级提示中固件和参数版本的显示
const firmwareVersionNewer = ref(false);
const configVersionNewer = ref(false);

// 升级版本信息弹窗相关变量
const versionInfoVisible = ref(false)
const upgradeVersionInfo = ref({
  oldFirmwareVersion: '',
  newFirmwareVersion: '',
  oldParameterVersion: '',
  newParameterVersion: ''
})

// 升级状态相关变量
const isUpgrading = ref(false)
const upgradeProgress = ref(0)
const upgradeMessage = ref('')
const upgradeStatus = ref('')
const uploadCompleted = ref(false)

// 新增查看最近文件相关的响应式变量
const recentFilesVisible = ref(false)
const recentFilesActiveTab = ref('firmware')
const recentFirmwareList = ref([])
const recentParameterList = ref([])

// 不需要直接修改props，通过在父组件中设置uploadFiles的fileName来实现同步

// 组件卸载时清理定时器
onUnmounted(() => {
  if (upgradeHistoryTimer.value) {
    clearTimeout(upgradeHistoryTimer.value);
    upgradeHistoryTimer.value = null;
  }
})

// 组件挂载时初始化版本信息
onMounted(() => {
  // 检查是否有升级标记
  const hasUpgradeRecord = localStorage.getItem(`hasUpgraded_${props.code}`);
  hasUpgraded.value = (hasUpgradeRecord === 'true');
  
  // 检查是否应该显示升级历史（页面刷新后恢复显示状态）
  const shouldShow = localStorage.getItem(`upgradeHistoryShouldShow_${props.code}`);
  const showStartTime = localStorage.getItem(`upgradeHistoryShowStart_${props.code}`);
  
  if (shouldShow === 'true' && showStartTime && hasUpgraded.value) {
    const startTime = parseInt(showStartTime);
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
    const maxDisplayTime = 30 * 60 * 1000; // 30分钟
    
    if (elapsedTime < maxDisplayTime) {
      // 还在显示时间内，继续显示升级历史
      showUpgradeHistory.value = true;
      
      // 设置剩余时间的定时器
      const remainingTime = maxDisplayTime - elapsedTime;
      upgradeHistoryTimer.value = setTimeout(() => {
        showUpgradeHistory.value = false;
        upgradeHistoryTimer.value = null;
        // 清除localStorage中的显示状态
        localStorage.removeItem(`upgradeHistoryShouldShow_${props.code}`);
        localStorage.removeItem(`upgradeHistoryShowStart_${props.code}`);
      }, remainingTime);
    } else {
      // 已超过显示时间，清除localStorage中的显示状态
      localStorage.removeItem(`upgradeHistoryShouldShow_${props.code}`);
      localStorage.removeItem(`upgradeHistoryShowStart_${props.code}`);
    }
  } else {
    // 初始化时不显示升级历史，只有当新的升级完成时才显示
    showUpgradeHistory.value = false;
  }
  
  // 如果有升级记录，从upgradeHistory获取升级前版本
  if (hasUpgraded.value) {
    const savedOldVersion = localStorage.getItem(`upgradeStartVersion_${props.code}`);
    if (savedOldVersion) {
      upgradeHistory.value = [{
        oldVersion: savedOldVersion,
        upgradeTime: new Date().toLocaleString()
      }];
    }
  }
  
  // 保存当前版本到localStorage，作为后续升级的旧版本参考
  const currentVersion = getCurrentFirmwareVersion();
  if (currentVersion) {
    localStorage.setItem(`lastVersion_${props.code}`, currentVersion);
  }
})

// 组件初始化时加载最近文件列表，确保计算属性可以访问到数据
loadRecentFiles()

// 申请对话框相关变量
const applyDialogVisible = ref(false)
const applyFormRef = ref(null)
const applyForm = ref({
  applicantId: '',
  applyReason: '',
  applicantStatus: 'normal'
})

// 申请表单验证规则
const applyRules = ref({
  applyReason: [
    { required: true, message: t('ProductUpgrade.applyReasonRequired'), trigger: 'blur' },
    { min: 10, message: t('ProductUpgrade.applyReasonMinLength'), trigger: 'blur' }
  ],
  applicantStatus: [
    { required: true, message: t('ProductUpgrade.applicantStatusRequired'), trigger: 'change' }
  ]
})

async function check() {
  // 检查组织用户类型
  const organizationName = localStorage.getItem('organizationName');

  // 检查是否有可用的序列号升级文件（从props中获取）
  const hasSerialUpgrade = props.hasSerialUpgrade !== undefined ? props.hasSerialUpgrade : false;

  // 先加载最近文件列表，确保数据已加载
  await loadRecentFiles();

  if (organizationName === 'OGGI' && hasSerialUpgrade) {
    // 获取设备类型对应的序列号
    let serialNumber = '';
    if (props.infos && Array.isArray(props.infos)) {
      const snItem = props.infos.find(item => item.key === 'mcusncode');
      if (snItem) {
        serialNumber = snItem.value;
      }
    }

    // 只有当有序列号时才调用P8特定检查方法
    if (serialNumber) {
      // 调用父组件的P8特定检查方法
      props.checkUpgradeForP8 && props.checkUpgradeForP8(serialNumber, props.code)
          .then(result => {
            if (result) {
              // 如果找到了新文件，显示检查结果弹窗
              checkVisiable.value = true;
            } else {
              // 如果没有找到序列号升级文件，继续执行通用升级检查逻辑
              // 先检查是否有新文件（OGGI、L1、Atala组织的通用逻辑）
              const currentFirmwareVersion = getCurrentFirmwareVersion();
              const currentParameterVersion = getCurrentParameterVersion();
              
              // 默认不显示升级提示
              checkVisiable.value = false;
              firmwareVersionNewer.value = false;
              configVersionNewer.value = false;
              
              // 检查固件文件版本
              if (props.lastFirmwareFile && recentFirmwareList.value.length > 0) {
                // 提取当前选中的文件名
                const firmwareFileName = props.lastFirmwareFile.substring(props.lastFirmwareFile.lastIndexOf('\\') + 1);
                
                // 查找与当前文件名匹配的固件信息
                const matchingFirmware = recentFirmwareList.value.find(item =>
                  item.name && item.file_name === firmwareFileName
                );
                
                const serverFirmwareVersion = matchingFirmware ? matchingFirmware.software_version || '' : '';
                if (serverFirmwareVersion && currentFirmwareVersion) {
                  const firmwareVersionCompareResult = compareversions(serverFirmwareVersion, currentFirmwareVersion);
                  if (firmwareVersionCompareResult > 0) {
                    firmwareVersionNewer.value = true;
                  }
                }
              }
              
              // 检查参数文件版本
              if (props.lastConfigFile && recentParameterList.value.length > 0) {
                // 提取当前选中的文件名
                const configFileName = props.lastConfigFile.substring(props.lastConfigFile.lastIndexOf('\\') + 1);
                
                // 查找与当前文件名匹配的参数信息
                const matchingConfig = recentParameterList.value.find(item => 
                  item.name && item.file_name === configFileName
                );
                
                const serverConfigVersion = matchingConfig ? matchingConfig.config_version || '' : '';
                if (serverConfigVersion && currentParameterVersion) {
                  const configVersionCompareResult = compareversions(serverConfigVersion, currentParameterVersion);
                  if (configVersionCompareResult > 0) {
                    configVersionNewer.value = true;
                  }
                }
              }
              
              // 如果固件版本或参数文件版本有任何一个大于当前版本，就显示升级提示
              checkVisiable.value = firmwareVersionNewer.value || configVersionNewer.value;

              
              if (!checkVisiable.value) {
                // 如果没有新文件，对于Atala组织，执行特殊的接口调用逻辑
                if (organizationName === 'Atala') {
                  // 准备接口参数 - 只传递version和organization_id两个参数
                  const organizationId = localStorage.getItem('organizationId');
                  // 从props.infos中获取设备版本号
                  let currentVersion = '';
                  if (props.infos && Array.isArray(props.infos)) {
                    // 根据不同设备类型获取对应的版本信息
                    if (props.code === 'motor') {
                      // 电机设备获取软件版本
                      const versionItem = props.infos.find(item => item.key === 'softwareversion');
                      if (versionItem) {
                        currentVersion = versionItem.value || '';
                      }
                    } else if (props.code === 'display') {
                      // 仪表设备获取版本信息
                      const versionItem = props.infos.find(item => item.key === 'softwareversion');
                      if (versionItem) {
                        currentVersion = versionItem.value || '';
                      }
                    } else if (props.code === 'battery') {
                      // 电池设备获取版本信息
                      const versionItem = props.infos.find(item => item.key === 'softwareversion');
                      if (versionItem) {
                        currentVersion = versionItem.value || '';
                      }
                    }
                  }
                  
                  let params = {
                    "organization_id-eq": organizationId,
                    "version-eq": currentVersion.substring(0, 4)
                  };

                  // 直接检查新的api/firmware-versions接口（因为已经确定没有可升级固件了）
                  api.checkLatestFirmware(params).then(latestFirmwareRes => {
                    // 检查api/firmware-versions接口是否有返回数据
                    const hasNewApiData = latestFirmwareRes?.data && latestFirmwareRes.data.length > 0;

                    // 如果从/xxx接口查到了，提示"此产品已经是最新版本"
                    if (hasNewApiData) {
                      ElMessage.info(t('ProductUpgrade.alreadyLatestVersion'));
                    } 
                    // 如果/xxx接口没查到，提示"此产品为旧版本固件，请选择手动升级功能"
                    else {
                      ElMessage.info(t('ProductUpgrade.oldVersionManualUpgrade'));
                    }
                  }).catch(() => {
              
                  });
                } else {
                  // 对于OGGI和L1组织，直接提示无新版本
                  ElMessage.info(t('ProductUpgrade.noNewVersion'));
                }
              }
            }
          })
          .catch(() => {
            // 出错时也执行通用升级检查逻辑
            // 先检查是否有新文件（OGGI、L1、Atala组织的通用逻辑）
            const currentFirmwareVersion = getCurrentFirmwareVersion();
            const currentParameterVersion = getCurrentParameterVersion();
            
            // 默认不显示升级提示
            checkVisiable.value = false;
            firmwareVersionNewer.value = false;
            configVersionNewer.value = false;
            
            // 检查固件文件版本
            if (props.lastFirmwareFile && recentFirmwareList.value.length > 0) {
              // 提取当前选中的文件名
              const firmwareFileName = props.lastFirmwareFile.substring(props.lastFirmwareFile.lastIndexOf('\\') + 1);
              
              // 查找与当前文件名匹配的固件信息
              const matchingFirmware = recentFirmwareList.value.find(item =>
                item.name && item.file_name === firmwareFileName
              );
              
              const serverFirmwareVersion = matchingFirmware ? matchingFirmware.software_version || '' : '';
              if (serverFirmwareVersion && currentFirmwareVersion) {
                const firmwareVersionCompareResult = compareversions(serverFirmwareVersion, currentFirmwareVersion);
                if (firmwareVersionCompareResult > 0) {
                  firmwareVersionNewer.value = true;
                }
              }
            }
            
            // 检查参数文件版本
            if (props.lastConfigFile && recentParameterList.value.length > 0) {
              // 提取当前选中的文件名
              const configFileName = props.lastConfigFile.substring(props.lastConfigFile.lastIndexOf('\\') + 1);
              
              // 查找与当前文件名匹配的参数信息
              const matchingConfig = recentParameterList.value.find(item => 
                item.name && item.file_name === configFileName
              );
              
              const serverConfigVersion = matchingConfig ? matchingConfig.config_version || '' : '';
              if (serverConfigVersion && currentParameterVersion) {
                const configVersionCompareResult = compareversions(serverConfigVersion, currentParameterVersion);
                if (configVersionCompareResult > 0) {
                  configVersionNewer.value = true;
                }
              }
            }
            
            // 如果固件版本或参数文件版本有任何一个大于当前版本，就显示升级提示
            checkVisiable.value = firmwareVersionNewer.value || configVersionNewer.value;

            
            if (!checkVisiable.value) {
              // 对于OGGI和L1组织，直接提示无新版本
              ElMessage.info(t('ProductUpgrade.noNewVersion'));
            }
          });
    } else {
      // 没有序列号时，直接执行通用升级检查逻辑
      // 先检查是否有新文件（OGGI、L1、Atala组织的通用逻辑）
      const currentFirmwareVersion = getCurrentFirmwareVersion();
      const currentParameterVersion = getCurrentParameterVersion();
      
      // 默认不显示升级提示
      checkVisiable.value = false;
      firmwareVersionNewer.value = false;
      configVersionNewer.value = false;
      
      // 检查固件文件版本
      if (props.lastFirmwareFile && recentFirmwareList.value.length > 0) {
        // 提取当前选中的文件名
        const firmwareFileName = props.lastFirmwareFile.substring(props.lastFirmwareFile.lastIndexOf('\\') + 1);
        
        // 查找与当前文件名匹配的固件信息
        const matchingFirmware = recentFirmwareList.value.find(item =>
          item.name && item.file_name === firmwareFileName
        );
        
        const serverFirmwareVersion = matchingFirmware ? matchingFirmware.software_version || '' : '';
        if (serverFirmwareVersion && currentFirmwareVersion) {
          const firmwareVersionCompareResult = compareversions(serverFirmwareVersion, currentFirmwareVersion);
          if (firmwareVersionCompareResult > 0) {
            firmwareVersionNewer.value = true;
          }
        }
      }
      
      // 检查参数文件版本
      if (props.lastConfigFile && recentParameterList.value.length > 0) {
        // 提取当前选中的文件名
        const configFileName = props.lastConfigFile.substring(props.lastConfigFile.lastIndexOf('\\') + 1);
        
        // 查找与当前文件名匹配的参数信息
        const matchingConfig = recentParameterList.value.find(item => 
          item.name && item.file_name === configFileName
        );
        
        const serverConfigVersion = matchingConfig ? matchingConfig.config_version || '' : '';
        if (serverConfigVersion && currentParameterVersion) {
          const configVersionCompareResult = compareversions(serverConfigVersion, currentParameterVersion);
          if (configVersionCompareResult > 0) {
            configVersionNewer.value = true;
          }
        }
      }
      
      // 如果固件版本或参数文件版本有任何一个大于当前版本，就显示升级提示
      checkVisiable.value = firmwareVersionNewer.value || configVersionNewer.value;

      
      if (!checkVisiable.value) {
        // 对于OGGI和L1组织，直接提示无新版本
        ElMessage.info(t('ProductUpgrade.noNewVersion'));
      }
    }
  } else if (organizationName === 'OGGI' || organizationName === 'L1' || organizationName === 'Atala') {
    // 先检查是否有新文件（OGGI、L1、Atala组织的通用逻辑）
    const currentFirmwareVersion = getCurrentFirmwareVersion();
    const currentParameterVersion = getCurrentParameterVersion();
    
    // 默认不显示升级提示
    checkVisiable.value = false;
    firmwareVersionNewer.value = false;
    configVersionNewer.value = false;
    
    // 检查固件文件版本
    if (props.lastFirmwareFile && recentFirmwareList.value.length > 0) {
      // 提取当前选中的文件名
      const firmwareFileName = props.lastFirmwareFile.substring(props.lastFirmwareFile.lastIndexOf('\\') + 1);
      
      // 查找与当前文件名匹配的固件信息
      const matchingFirmware = recentFirmwareList.value.find(item =>
        item.name && item.file_name === firmwareFileName
      );
      
      const serverFirmwareVersion = matchingFirmware ? matchingFirmware.software_version || '' : '';
      if (serverFirmwareVersion && currentFirmwareVersion) {
        const firmwareVersionCompareResult = compareversions(serverFirmwareVersion, currentFirmwareVersion);
        if (firmwareVersionCompareResult > 0) {
          firmwareVersionNewer.value = true;
        }
      }
    }
    
    // 检查参数文件版本
    if (props.lastConfigFile && recentParameterList.value.length > 0) {
      // 提取当前选中的文件名
      const configFileName = props.lastConfigFile.substring(props.lastConfigFile.lastIndexOf('\\') + 1);
      
      // 查找与当前文件名匹配的参数信息
      const matchingConfig = recentParameterList.value.find(item => 
        item.name && item.file_name === configFileName
      );
      
      const serverConfigVersion = matchingConfig ? matchingConfig.config_version || '' : '';
      if (serverConfigVersion && currentParameterVersion) {
        const configVersionCompareResult = compareversions(serverConfigVersion, currentParameterVersion);
        if (configVersionCompareResult > 0) {
          configVersionNewer.value = true;
        }
      }
    }
    
    // 如果固件版本或参数文件版本有任何一个大于当前版本，就显示升级提示
    checkVisiable.value = firmwareVersionNewer.value || configVersionNewer.value;

   
    if (!checkVisiable.value) {
      // 如果没有新文件，对于Atala组织，执行特殊的接口调用逻辑
      if (organizationName === 'Atala') {
        // 准备接口参数 - 只传递version和organization_id两个参数
        const organizationId = localStorage.getItem('organizationId');
        // 从props.infos中获取设备版本号
        let currentVersion = '';
        if (props.infos && Array.isArray(props.infos)) {
          // 根据不同设备类型获取对应的版本信息
          if (props.code === 'motor') {
            // 电机设备获取软件版本
            const versionItem = props.infos.find(item => item.key === 'softwareversion');
            if (versionItem) {
              currentVersion = versionItem.value || '';
            }
          } else if (props.code === 'display') {
            // 仪表设备获取版本信息
            const versionItem = props.infos.find(item => item.key === 'softwareversion');
            if (versionItem) {
              currentVersion = versionItem.value || '';
            }
          } else if (props.code === 'battery') {
            // 电池设备获取版本信息
            const versionItem = props.infos.find(item => item.key === 'softwareversion');
            if (versionItem) {
              currentVersion = versionItem.value || '';
            }
          } else if (props.code === 'box') {
            // 盒子设备获取版本信息
            const versionItem = props.infos.find(item => item.key === 'softwareversion');
            if (versionItem) {
              currentVersion = versionItem.value || '';
            }
          }
        }
        
        let params = {
          "organization_id-eq": organizationId,
          "version-eq": currentVersion.substring(0, 4)
        };

        // 直接检查新的api/firmware-versions接口（因为已经确定没有可升级固件了）
        api.checkLatestFirmware(params).then(latestFirmwareRes => {
          // 检查api/firmware-versions接口是否有返回数据
          const hasNewApiData = latestFirmwareRes?.data && latestFirmwareRes.data.length > 0;

          // 如果从/xxx接口查到了，提示"此产品已经是最新版本"
          if (hasNewApiData) {
            ElMessage.info(t('ProductUpgrade.alreadyLatestVersion'));
          } 
          // 如果/xxx接口没查到，提示"此产品为旧版本固件，请选择手动升级功能"
          else {
            ElMessage.info(t('ProductUpgrade.oldVersionManualUpgrade'));
          }
        }).catch(() => {
    
        });
      } else {
        // 对于OGGI和L1组织，直接提示无新版本
        ElMessage.info(t('ProductUpgrade.noNewVersion'));
      }
    }
  } else {
    // 非OGGI、非L1、非Atala组织用户不显示升级提示
    ElMessage.info(t('ProductUpgrade.noNewVersion'));
  }
}

function checkAndUpgrade() {
  checkVisiable.value = false
  props.checkUpgrade(props.lastFirmwareFile, props.lastConfigFile, props.code)
}

function beforeUpload(file){

  const token = localStorage.getItem('token')

  if (!token) {
    router.push('/LoginPage')
    return false
  }

  if(file.type != 'application/octet-stream'){
    ElMessage.error("please select bin file")
    return false
  }
  return true
}

// 新增查看最近文件的方法
function showRecentFiles() {
  recentFilesVisible.value = true
  loadRecentFiles()
}

function handleRecentFilesTabChange(tabName) {
  recentFilesActiveTab.value = tabName
  loadRecentFiles()
}

function loadRecentFiles() {
  return new Promise((resolve) => {
    const organizationId = localStorage.getItem('organizationId')
    
    // 根据当前设备类型确定需要加载哪些数据
    let promises = []
    
    if (props.code === 'motor') {
      // 电机设备需要加载固件和参数
      promises.push(loadTabData('firmware'))
      promises.push(loadTabData('parameter'))
    } else if (props.code === 'display') {
      // 仪表设备只加载固件
      promises.push(loadTabData('firmware'))
    } else if (props.code === 'battery') {
      // 电池设备只加载固件
      promises.push(loadTabData('firmware'))
    } else if (props.code === 'box') {
      // 盒子设备只加载固件
      promises.push(loadTabData('firmware'))
    }
    
    Promise.all(promises).then(() => {
      resolve()
    }).catch(() => {
      resolve()
    })
    
    function loadTabData(tabType) {
      return new Promise((resolve, reject) => {
        // 根据当前设备类型和tab类型确定API参数
        let params = {
          organization_id: organizationId,
        }

        if (props.code === 'motor') {
          // 电机设备
          if (tabType === 'firmware') {
            params.type = 0 // 电机固件
            params.productType = 0
          } else {
            params.type = 1 // 电机参数文件
            params.productType = 0
          }
        } else if (props.code === 'display') {
          // 仪表设备 - 只显示固件
          params.type = 2 // 仪表固件
          params.productType = 1
        } else if (props.code === 'battery') {
          // 电池设备 - 不进行自动升级
          resolve()
          return
        } else if (props.code === 'box') {
          // 盒子设备 - 只显示固件
          params.type = 3 // 盒子固件
          params.productType = 3
        }

        api.firmwareList(params).then(res => {
          if (res?.code === 0) {
            const data = res.data.map(item => ({
              ...item,
              hardware_version: item.productModels ? item.productModels.map(model => model.hardware_version).join(', ') : '-',
              software_version: item.productModels ? item.productModels.map(model => model.software_version).join(', ') : '-',
              config_version: item.productModels ? item.productModels.map(model => model.config_version).join(', ') : '-',
            }))
            // 按id降序排序，确保最新的固件排在前面
            data.sort((a, b) => b.id - a.id)

            if (tabType === 'firmware') {
              recentFirmwareList.value = data
            } else if (tabType === 'parameter' && props.code === 'motor') {
              recentParameterList.value = data
            }
          }
          resolve()
        }).catch(error => {
          console.error(`Failed to load ${tabType} files:`, error)
          reject(error)
        })
      })
    }
  })
}

// 申请对话框相关方法
function showApplyDialog() {
  // 设置申请人ID为当前用户ID
  applyForm.value.applicantId = props.upgradeCountInfo.userId || localStorage.getItem('userId')
  applyForm.value.applyReason = ''
  applyDialogVisible.value = true
}

function closeApplyDialog() {
  applyDialogVisible.value = false
  // 重置表单
  if (applyFormRef.value) {
    applyFormRef.value.resetFields()
  }
}

async function submitApply() {
  try {
    // 验证表单
    await applyFormRef.value.validate()

    // 调用申请接口 - 只保留content参数
    const requestData = {
      content: applyForm.value.applyReason
    }

    // 调用新的后端创建申请接口
    await createDiffUpgradeApplyRecord(requestData)

    // 显示成功提示
    ElMessage.success(t('ProductUpgrade.applySuccess'))

    // 关闭对话框（移除不必要的接口调用）
    closeApplyDialog()

  } catch (error) {
    if (error !== false) { // 不是表单验证错误
      console.error('申请升级次数失败:', error)
      ElMessage.error(t('ProductUpgrade.applyFailed'))
    }
  }
}



// 关闭版本信息弹窗
function closeVersionInfoDialog() {
  // 强制关闭版本信息弹窗
  versionInfoVisible.value = false
  
  // 执行原来点击完成按钮的操作
  // 触发重置升级状态的事件
  emit('resetUpgradeStatus')
  
  // 重置升级状态变量
  isUpgrading.value = false
  upgradeProgress.value = 0
  upgradeMessage.value = ''
  upgradeStatus.value = ''
  uploadCompleted.value = false
  
  // 清除本地存储的升级开始版本
  localStorage.removeItem(`upgradeStartVersion_${props.code}`)
}

// 处理版本信息弹窗的model-value更新
function handleVersionInfoDialogUpdate(value) {
  const organizationName = localStorage.getItem('organizationName')
  
  // 只有Atala组织才允许更新弹窗状态
  if (organizationName === 'Atala') {
    versionInfoVisible.value = value
  } else {
    // 非Atala组织强制保持弹窗关闭状态
    versionInfoVisible.value = false
  }
}

</script>